import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { OptionsObject, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ComingSoon } from "../../comingsoon/ComingSoon";
import GoogleTouchPointDefaultPage from "./GoogleTouchPointDefaultPage";
import {
  createTouchPoint,
  followGoogleSearchQuery,
  getAllTouchPoints,
  getFollowingGoogleSearchQueries,
} from "../../../api/specialization/SocialSpecializationAPI";
import { AlertSuccessProp } from "../../../components/SnackbarNoti";
import SelectAllTransferList from "../../../components/TransferListField";

export function GoogleTouchPointsList() {
  const { t } = useTranslation(["common", "social", "keyword"]);
  const [openDialog, setOpenDialog] = useState(false);
  const [forceReload, setForceReload] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [flowName, setFlowName] = useState("");
  const [flows, setFlows] = useState([]);
  const [queries, setQueries] = useState([]);
  const [chosenQueries, setChosenQueries] = useState([]);

  useEffect(() => {
    getFollowingGoogleSearchQueries().then((res) => {
      setQueries(res);
    });
    getAllTouchPoints().then((res) => {
      setFlows(res);
    });
  }, [forceReload]);

  var pageContent = <GoogleTouchPointDefaultPage></GoogleTouchPointDefaultPage>;

  if (flows.length > 0) {
  }
  return (
    <div>
      <Box display={"flex"} justifyContent={"flex-begin"} marginBottom={"20px"}>
        <Button
          variant="contained"
          color="success"
          style={{ width: "120px", marginRight: "30px" }}
          onClick={() => {
            setOpenDialog(true);
          }}
        >
          {t("common:create")}
        </Button>
        <Dialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          maxWidth="md"
          
          fullWidth
        >
          <DialogTitle>{t("social:query")}</DialogTitle>
          <DialogContent sx={{height: "70vh"}}>
            <TextField
              margin="dense"
              id="name"
              label={t("social:query")}
              placeholder={t("social:query").toString()}
              fullWidth
              required
              variant="standard"
              onChange={(e) => {
                setFlowName((e.target as HTMLInputElement).value);
              }}
            ></TextField>
            <SelectAllTransferList
              left={queries}
              right={[]}
              displayField="query"
              onChosen={(value) => {
                setChosenQueries(value);
              }}
            />
            <DialogActions sx={{ marginTop: "20px" }}>
              <Button
                variant="contained"
                onClick={() => {
                  var queryIDs = chosenQueries.map((e) => {
                    return { id: e.id };
                  });
                  if (flowName.length > 0) {
                    createTouchPoint(flowName, queryIDs).then((res) => {
                      enqueueSnackbar(
                        t("common:update_successfully"),
                        AlertSuccessProp as OptionsObject
                      );
                      setForceReload(!forceReload);
                    });
                    setOpenDialog(false);
                  }
                }}
              >
                Submit
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </Box>
      {pageContent}
    </div>
  );
}
